import React from 'react';
import { Box, Button, Grid, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { otpModeAdded } from '../../store/users';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const SelectOTPMethod = ({ onNext, onBack, buttonName }) => {
    const dispatch = useDispatch()

    const submitMode = (item) => {
        dispatch(otpModeAdded(item))
        onNext()
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", textAlign: 'center', gap: "8px" }}>
            <Box sx={{ display: 'flex', justifyContent: 'flex-start', mb: 2 }}>
                <Button
                    variant="outlined"
                    color="secondary"
                    sx={{
                        border: 'none',
                        '&:hover': {
                            border: 'none',
                        }
                    }}
                    onClick={onBack}
                >
                    <ArrowBackIcon/> Back
                </Button>
            </Box>
            <Typography variant="h5" sx={{ fontWeight: '600', paddingBottom:"5px" }}>{buttonName}?</Typography>
            <Typography variant="h6" sx={{ fontSize: "16px", paddingBottom:"5px" }}>Verify Your Identity</Typography>
            <Typography variant="h6" sx={{ fontSize: "16px", paddingBottom:"5px" }}>You will now be required to enter One-Time Security Code to verify your identity.</Typography>
            <Typography variant="h6" sx={{ fontSize: "16px", paddingBottom:"7px" }}>Where would you like to receive the OTP?</Typography>

            <Grid container spacing={2} sx={{marginTop:"10px"}}>
                <Grid item xs={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                            mb: 2,
                            backgroundColor: "#f5365c",
                            borderColor: "#f5365c",
                            '&:hover': {
                                backgroundColor: '#f5365c',
                                color: 'white',
                                border: 'none',
                            }
                        }}
                        onClick={() => submitMode('Email')}>
                        Send to Email
                    </Button>
                </Grid>
                <Grid item xs={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                            mb: 2,
                            backgroundColor: "#f5365c",
                            borderColor: "#f5365c",
                            '&:hover': {
                                backgroundColor: '#f5365c',
                                color: 'white',
                                border: 'none',
                            }
                        }}
                        onClick={() => submitMode('Mobile')}>
                        Text to Mobile
                    </Button>
                </Grid>
                <Grid item xs={4}>
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        sx={{
                            mb: 2,
                            backgroundColor: "#f5365c",
                            // textTransform: 'none',
                            borderColor: "#f5365c",
                            '&:hover': {
                                backgroundColor: '#f5365c',
                                color: 'white',
                                border: 'none',
                            }
                        }}
                        onClick={() => submitMode('Email')}>
                        Security Question
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default SelectOTPMethod;
